import request from '@/utils/request'
import { baseUrl1, baseUrl5 } from "./baseUrl";
import { compareIdentifiers } from 'semver';


//退出；
export function logout() {
    return request({
        url: baseUrl1 + '/api/user/logout?type=1',
        method: 'post'
    })
}
//登录；
export function login(params) {
    return request({
        url: baseUrl5 + '/common/login',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

// export function getInfo() {
//   return request({
//     url: baseUrl5 + '/api/common/info',
//     method: 'get'
//   })
// }

//获取验证码
export function getVerify() {
    return request({
        url: baseUrl5 + '/common/getVerify',
        method: 'get'
    })
}
//修改密码
export function ModifyPwd(params) {
    return request({
        url: baseUrl1 + '/api/user/modifyPassword',
        data: params,
        datatype: 'json',
        // url: 'crm/crm-user' + '/api/user/modifyPassword',
        method: 'post'
    })
}
export function modifyHead(params) {
    return request({
        url: baseUrl1 + '/api/user/modifyHead',
        data: params,
        datatype: 'json',
        
        method: 'post'
    })
}


//发送验证码/common/sendSms
export function sentSms(phone){
    return request({
        url:baseUrl5 + '/common/sendSms?phone='+phone,
        method:'post'
    })
}
//验证短信验证码/common/checkSmsCode
export function checkSmsCode(phone,code){
    return request({
        url:baseUrl5 + '/common/checkSmsCode?phone='+phone+'&code='+code,
        method:'post'
    })
}
//修改密码api/user/updatePassword
export function updatePassword(phone,password){
    return request({
        url:baseUrl5 + '/common/updatePassword?phone='+phone+'&password='+password,
        method:'post'
    })
}

//记录用户行为埋点
export function insertUserBehavior(params) {
    return request({
        url: baseUrl1 + '/api/user/insertUserBehavior',
        data: params,
        datatype: 'json',
        method: 'post'
    })
}
// 联系我们
export function contactUs(params) {
    return request({
        url: baseUrl5 + '/common/contactUs',
        method: 'post',
        datatype: 'json',
        data: params
    })
}

// 获取省市区json数据
//发送验证码/common/sendSms
export function getAreaJson(){
    return request({
        url:baseUrl5 + '/api/sysconfig/getAreaJson',
        method:'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/common.js